'use client';
import React, { useEffect, useRef } from 'react';
import styles from './Animate.module.css';

interface AnimateProps {
  animationName:
    | 'fadeIn'
    | 'slideLeft'
    | 'slideRight'
    | 'slideUp'
    | 'slideDown'
    | 'scaleIn'
    | 'rotateIn'
    | 'clipPathIn';
  delay?: '100' | '200' | '300' | '400' | '500';
  children: React.ReactNode;
  threshold?: number;
}

export const Animate: React.FC<AnimateProps> = ({
  animationName,
  delay,
  children,
  threshold = 0.2,
}) => {
  const elementRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const animationClass = styles[animationName];
            const delayClass = delay ? styles[`delay-${delay}`] : '';

            entry.target.classList.add(animationClass);
            if (delayClass) entry.target.classList.add(delayClass);

            observer.unobserve(entry.target);
          }
        });
      },
      { threshold }
    );

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [animationName, delay, threshold]);

  return (
    <div ref={elementRef} className={styles.animatedElement}>
      {children}
    </div>
  );
};
